module.exports = {
  EDIT_MRD_SETTINGS_FAILURE: 'EDIT_MRD_SETTINGS_FAILURE',
  EDIT_MRD_SETTINGS_REQUEST: 'EDIT_MRD_SETTINGS_REQUEST',
  EDIT_MRD_SETTINGS_SUCCESS: 'EDIT_MRD_SETTINGS_SUCCESS',
};
